import { render, staticRenderFns } from "./simpleModal.vue?vue&type=template&id=735f0c5d"
import script from "./simpleModal.vue?vue&type=script&lang=ts"
export * from "./simpleModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports